// extracted by mini-css-extract-plugin
module.exports = {"card":"CaseCard_card__3AuUW","cover":"CaseCard_cover__1s8EB","image":"CaseCard_image__13oFC"};